<template>
  <div class="hw-grid">
    <HrWorkforcePanel
      v-for="donut in visibleDonuts"
      :key="donut.title"
      :title="donut.title"
      :note="recordedCount(donut.items) + ' of ' + current.total + ' recorded'"
    >
      <div class="hw-donut-wrap">
        <HrWorkforceDonut class="hw-donut-chart" :items="donut.items" :total="current.total" :value="onlyCommaFormat(current.total)" caption="staff" />
        <HrWorkforceLegend class="hw-donut-legend" :items="donut.items" :total="current.total" />
      </div>
    </HrWorkforcePanel>
  </div>
</template>

<script setup>
import { toRef } from 'vue'
import figureFormatter from '@/services/utils/figureFormatter'
import { recordedCount, useHrWorkforceItems } from '@/components/molecule/company/dashboard/dynamic-dashboard/hr-workforce/common/hrWorkforce'
import HrWorkforcePanel from '@/components/molecule/company/dashboard/dynamic-dashboard/hr-workforce/common/HrWorkforcePanel.vue'
import HrWorkforceDonut from '@/components/molecule/company/dashboard/dynamic-dashboard/hr-workforce/common/HrWorkforceDonut.vue'
import HrWorkforceLegend from '@/components/molecule/company/dashboard/dynamic-dashboard/hr-workforce/common/HrWorkforceLegend.vue'

const props = defineProps({
  current: { type: Object, required: true },
  labels: { type: Object, required: true }
})

const { onlyCommaFormat } = figureFormatter()
const { visibleDonuts } = useHrWorkforceItems(toRef(props, 'current'), toRef(props, 'labels'))
</script>

<style scoped src="./common/hrWorkforce.css"></style>

<style scoped>
.hw-donut-wrap {
  display: flex;
  align-items: center;
  gap: 18px;
}
.hw-donut-legend {
  flex: 1;
  min-width: 0;
}
@media (max-width: 575px) {
  .hw-donut-wrap {
    flex-direction: column;
    align-items: stretch;
  }
  .hw-donut-chart {
    align-self: center;
  }
}
</style>
